import StatCard from '@/components/dashboard/StatCard';
import { DailyOrderMetricsResult } from '@/models/OrderMetrics';
import { formatPrice } from '@/utils/currency';
import { ChartBarIcon } from '@heroicons/react/24/solid';

interface DailyOrderMetricsStatsProps {
  daily?: DailyOrderMetricsResult;
  isLoading: boolean;
  currencyCode?: string;
  limit: number;
}

const DailyOrderMetricsStats = ({
  daily,
  isLoading,
  currencyCode,
  limit = 5,
}: DailyOrderMetricsStatsProps) => {
  const items =
    daily?.summary
      .slice()
      .sort((a, b) => b.day.getTime() - a.day.getTime())
      .slice(0, limit) ?? [];

  return (
    <StatCard
      icon={<ChartBarIcon className="h-8 w-8 text-slate-400 mt-1" />}
      loading={false}
      value={
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="border-b text-gray-700 font-medium">
              <tr>
                <th className="py-2 text-left">Date</th>
                <th className="py-2 text-right">Orders</th>
                <th className="py-2 text-right">Amount</th>
              </tr>
            </thead>

            <tbody>
              {isLoading &&
                Array.from({ length: limit }).map((_, i) => (
                  <tr key={`loading-${i}`} className="border-b last:border-none">
                    <td className="py-3">
                      <div className="h-4 bg-gray-200 animate-pulse rounded w-24" />
                    </td>
                    <td className="py-3 text-right">
                      <div className="h-4 bg-gray-200 animate-pulse rounded w-10 ml-auto" />
                    </td>
                    <td className="py-3 text-right">
                      <div className="h-4 bg-gray-200 animate-pulse rounded w-20 ml-auto" />
                    </td>
                  </tr>
                ))}

              {!isLoading &&
                items.map((m) => {
                  const label = m.day.toLocaleDateString('en-GB', {
                    month: 'short',
                    day: 'numeric',
                    year: '2-digit',
                  });

                  return (
                    <tr key={label} className="border-b last:border-none">
                      <td className="py-2">{label}</td>
                      <td className="py-2 text-right">{m.orderCount.toLocaleString()}</td>
                      <td className="py-2 text-right">
                        {formatPrice(m.orderAmount, currencyCode)}
                      </td>
                    </tr>
                  );
                })}

              {!isLoading && items.length === 0 && (
                <tr>
                  <td colSpan={3} className="py-3 text-center text-gray-500 italic">
                    No recent orders
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      }
    />
  );
};

export default DailyOrderMetricsStats;
